import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const CommentsCount = props => {
    const [count, setCount] = useState(0);
    const activities = useSelector(state => state.entities.Activities);

    useEffect(() => {
        let comments = null;
        if (props.listing.ActivityId) {
            var activity = activities[props.listing.ActivityId];
            if (activity)
                comments = activity.Comments;
        }
        setCount(comments ? comments.length : props.listing.CommentsCount);
    }, [props.listing, props.activities, activities])

    return <span className="comment_count">
        {count}
        <span className="listing_buttons_label">Comments</span>
    </span>
}

export default CommentsCount;